import React from "react";
import Reports from "../../modules/Reports";

const ReportPage = (props) => <Reports {...props} />;

export default ReportPage;
